export default __webpack_public_path__ + "static/media/Feather of Ibis.3231e712.jpg";